import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import { ButtonGroup } from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/styled-components'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import {
  selectClientTabHasUnsavedChanges,
  selectClientTabIsSaving,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useReviewLanguage from '@/containers/SubscriptionFormPageNew/Components/Contact/useReviewLanguage'

/**
 * Single "Save" button that orchestrates the four client-tab saves at once
 * (contact, address, electricity meter, gas meter). Replaces the four legacy
 * per-module save buttons. Mirrors the layout/positioning of the contracts
 * SaveButtons in TopHeader.
 */
const ClientSaveButtons = ({ hidden = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { isEditable } = useFormStatus()
  const { isReviewLanguageMissing } = useReviewLanguage()

  const isAnyModuleSaving = useSelector(selectClientTabIsSaving)
  const hasUnsavedChanges = useSelector(selectClientTabHasUnsavedChanges)

  const disabled = !isEditable || isAnyModuleSaving || !hasUnsavedChanges || isReviewLanguageMissing

  const handleSaveAll = () => {
    dispatch({
      type: subscriptionFormActionsV2.CLIENT_TAB_SAVE_ALL,
      enqueue,
    })
  }

  if (hidden) return null

  return (
    <ButtonGroup>
      <SDButton disabled={disabled} isLoading={isAnyModuleSaving} onClick={handleSaveAll}>
        {t('subscriptionForm:client_tab.save_all')}
      </SDButton>
    </ButtonGroup>
  )
}

ClientSaveButtons.propTypes = {
  hidden: PropTypes.bool,
}

export default ClientSaveButtons
